import { Socket } from 'socket.io-client';
import { authAxios } from '../services/axiosInstance';

// Le jeton est relu à chaque (re)connexion : il change après un refresh.
export const socketAuthOptions = {
    auth: (cb: (data: { token: string | null }) => void) => cb({ token: localStorage.getItem('token') }),
};

const MAX_RECOVERY_ATTEMPTS = 3;

/**
 * Si le serveur refuse la connexion parce que le jeton a expiré, on déclenche un refresh
 * (l'intercepteur axios s'en charge) puis on se reconnecte, quelques fois seulement.
 */
export const attachSocketAuthRecovery = (socket: Socket): void => {
    let attempts = 0;
    socket.on('connect', () => { attempts = 0; });
    socket.on('connect_error', async (err: Error) => {
        if (err.message !== 'unauthorized' || attempts >= MAX_RECOVERY_ATTEMPTS) return;
        attempts += 1;
        try {
            await authAxios.get('/auth/check-status');
        } catch {
            return; // session perdue : l'intercepteur redirige vers la connexion
        }
        socket.connect();
    });
};
